import { render, staticRenderFns } from "./ZoneTerritories.vue?vue&type=template&id=68a59bd2&"
import script from "./ZoneTerritories.vue?vue&type=script&lang=ts&"
export * from "./ZoneTerritories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports